export const CREATE_TUTORIAL = "CREATE_TUTORIAL";
export const Get_USER_DETAILS = "Get_USER_DETAILS";
export const UPDATE_TUTORIAL = "UPDATE_TUTORIAL";
export const DELETE_TUTORIAL = "DELETE_TUTORIAL";
export const DELETE_ALL_TUTORIALS = "DELETE_ALL_TUTORIALS";